//@flow
import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { createUGAndNavigate, UG_ERROR_RESET } from '../../../actions';
import { validateRequired, TextField, CTAButton, validateForm, Wrapper, updateStep, Modal} from 'h-signup';
import { Avatar, Title, SubTitle, ImageWrapper } from './styledComponents';
import { FormSection } from "../SetupSm/styledComponents";
import { ErrorMessage, ErrorTitle, ErrorAction } from '../Verify/styledComponents'
import ErrorIcon from '../../../../common/images/icecream-drop.png';
import { sendGenricTrackingEvent } from 'h-commons';
class GetStarted extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
            accName: {
                ref: null, value: ''
            },
			renderAccName: false,
			avatarUrl: '',
			firstName: '',
			submitError: false,
			submitInProgress: false
        }
		this.moveToNextStep = this.moveToNextStep.bind(this);
	}

	componentDidUpdate() {
        if (this.props.userDetails.submitError !== this.state.submitError) {
            const { submitError, submitInProgress } = this.props.userDetails;
            this.setState({
                submitError,
                submitInProgress
            });
        }
    }

	componentWillReceiveProps(nextProps) {
		if(nextProps.userDetails.firstName !== '') {
		const {renderAccName, avatarUrl, firstName} = nextProps.userDetails;
			this.setState({
				renderAccName,
				avatarUrl,
				firstName
			})
		}
	}

	moveToNextStep = async (event) => {
		const { renderAccName, accName } = this.state;
		event.preventDefault();
		sendGenricTrackingEvent('signupStarted',{ userid: this.props.userDetails.id });
		if(renderAccName){
			const validMap = { accName: false }
			const formValid = await validateForm(validMap, this.state, 1);
			if (!formValid) {
				return;
			}
			this.props.createUg({ accName: accName.value.trim() }, 'setup');
		} else {
			this.props.updateStep('setup');
		}
	}

	updateField = (value: string, target: string) => {
        this.setState({
            [target]: {
                ref: this.state[target].ref,
                value
            }
        })
    }

    updateRef = (ref: any, target: string) => {
        this.setState({
            [target]: {
                ref,
                value: this.state[target].value
            }
        })
    }

	getValidationObjects() {
        const required = {
            func: validateRequired,
            error: 'This is required'
        };
		return {
            required
        }
    }

	renderAccountName () {
		const { required } = this.getValidationObjects();
		const { submitInProgress } = this.state;

		return (
			<FormSection onSubmit={this.moveToNextStep} height="auto" flex={false}>
				<SubTitle style={{width: "383px"}}>
				Enter an account name to get started with creating your first Hiver shared mailbox.
				</SubTitle>
				<TextField label="Account Name"
					validations={[required]}
					onChange={value => this.updateField(value, 'accName')}
					innerRef={ref => this.updateRef(ref, 'accName')}
					placeholder={"Eg : ABC Support"}
					style={{marginLeft: "10px"}}
					LabelSectionStyle={{marginTop: "15px"}}
				/>
				<CTAButton width="294px" type="submit" isLoading={submitInProgress}>
					Next
				</CTAButton>
			</FormSection>
		)
	}

	renderWelcomeMessage (){
		return (
			<Fragment>
				<SubTitle>
					Get started with Hiver by setting up your first shared mailbox.
				</SubTitle>
				<CTAButton width="237px" onClick={this.moveToNextStep}>
						Next
				</CTAButton>
			</Fragment>
		)
	}

	renderError() {
		const { submitError } = this.state;
        if (!submitError) return null;
        return [
			<img key="error-icon" src={ErrorIcon} />,
			<ErrorTitle key="error-title">
                Error
            </ErrorTitle>,
			<ErrorMessage key="error-msg">
                { submitError.message || 'Some error occured. Please Try Again.'}
            </ErrorMessage>,
			<ErrorAction onClick={this.props.resetSubmitError} key="error-action">Retry</ErrorAction>
		]
	}

	render() {
		const { renderAccName, firstName, avatarUrl, submitError } = this.state;
		return (
			<Wrapper>
				<Avatar>
					<ImageWrapper>
					{
						avatarUrl && <img src={avatarUrl}/> 
					}
					</ImageWrapper>
				</Avatar>
				<Title capitalize> Welcome, {firstName}!</Title>
				{ renderAccName ? this.renderAccountName() : this.renderWelcomeMessage()}
				<Modal open={submitError} onClose={this.props.resetSubmitError}>
					{ this.renderError() }
				</Modal>
			</Wrapper>
		)
	}
}

type Props = {
	updateStep: Function,
	createUg: Function,
	userDetails: Object,
	resetSubmitError: Function
}

type State = {
	accName: Object,
	renderAccName: boolean,
	avatarUrl: string,
	firstName: string,
	submitError: boolean | Object,
	submitInProgress: boolean
}

const mapStateToProps = ({ signUp, userDetails }) => {
	return {
		signUp,
		userDetails
	};
};

const mapDispatchToProps = (dispatch: Function) => ({
	updateStep: (changeToRoute) => dispatch(updateStep(changeToRoute)),
	createUg: (reqObj, changeToRoute) => dispatch(createUGAndNavigate(reqObj, changeToRoute)),
	resetSubmitError: () => dispatch({ type: UG_ERROR_RESET})
});

export default connect(mapStateToProps, mapDispatchToProps)(GetStarted); 
